import { ArticleFlat, ArticleMeta } from 'types'
import { NERUDA_SCHEMA_VERSION } from 'utils/constants'
import { isNull, isUndefined } from 'lodash'
import store from 'redux/store'
import slugify from 'slugify'

import { isAlmanacCoreWorkspace } from './workspaceUtils'

export const hasNonDefaultCoverImage = (article: ArticleFlat) => {
  const { cover_image_url, is_default_cover_image } = article
  return cover_image_url && !is_default_cover_image
}

export const canRenderCoverPhoto = (article: ArticleMeta) => {
  if (!article) return false

  const { cover_image_url, is_default_cover_image } = article

  return !!cover_image_url && !is_default_cover_image
}

export const isExternalResource = (article: ArticleFlat | ArticleMeta | null | undefined) => {
  return !!article?.external_link
}

export const copyTextToClipboard = (text: string) => {
  navigator.clipboard.writeText(text)
}

export const generatePassword = (
  passwordLength: number,
  passwordChars: string = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
): string =>
  [...window.crypto.getRandomValues(new Uint32Array(passwordLength))]
    .map((x) => passwordChars[x % passwordChars.length])
    .join('')

export const isNerudaDoc = (article: ArticleFlat | ArticleMeta | undefined | null) => {
  return article?.schema_version === NERUDA_SCHEMA_VERSION
}

export const currentlyInCore = (article: ArticleMeta | ArticleFlat | undefined | null = null) => {
  const loadingArticle = isUndefined(article) || isNull(article)

  // Before loading the article, Almanac assumes we're on core.
  if (loadingArticle) return true

  const publicArticle = !!article?.made_public_at
  const isCoreWorkspace = isAlmanacCoreWorkspace(store.getState().workspace.currentWorkspaceId)

  return isCoreWorkspace && publicArticle
}

export const generateSeoString = (title: string, key: string) => [slugify(title, { lower: true }), key].join('-')
